module.exports = __webpack_public_path__ + "static/media/icpre_tek_new_logo1.4bda776a.png";